import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AccessibilityMenu from "./AccessibilityMenu";
import RouteAnnouncer from "./RouteAnnouncer";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-cream text-viola dark:bg-[hsl(var(--brand-bg))] dark:text-cream">
      <a href="#contenuto" className="skip-link" data-testid="skip-link">Vai al contenuto principale</a>
      <RouteAnnouncer />
      <Navbar />
      <main id="contenuto" tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      <Footer />
      <AccessibilityMenu />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}
